import React, { useState } from 'react';
import { useMountEffect } from '../hooks';
import Request from '../components/AxiosInstance';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';

export default function Footer() {

	function FirstLine() {
		return (
			<Typography variant="body1" color="text.secondary" textAlign="center">
				© {new Date().getFullYear()}
				<Link target="_blank" color="primary" href="https://capsovision.com/" sx={{ px: 1 }}>
					CapsoVision Inc.
				</Link>
				MyCapso {curVer.ver}
			</Typography>
		);
	}

	function SecondLine() {
		return (
			<Typography variant="body1" textAlign="center">
				<Link target="_blank" color="primary" href="https://capsovision.com/patient-portal-instructions-for-use/" sx={{ px: 1 }}>
					Help
				</Link>
				<Link target="_blank" color="primary" href="https://capsovision.com/patient-portal-privacy-policy/" sx={{ pl: 1 }}>
					Privacy Policy
				</Link>
			</Typography>
		)
	}

	const [curVer, setVer] = useState({
		ver: '',
	})

	const loadVersion = async () => {
		const verObj = await Request.get('/ver');
		setVer(verObj)
	}

	useMountEffect(loadVersion)

	return (
		<Box
			component="footer"
			sx={{
				py: 3,
				px: 2,
				mt: 'auto',
				backgroundColor: (theme) =>
					theme.palette.mode === 'light'
						? theme.palette.grey[100]
						: theme.palette.grey[800],
			}}
		>
			<Container maxWidth="md">
				<FirstLine />
				<SecondLine />
			</Container>
		</Box>
	)

}

